import Header from "../../component/Header/Header";
import styles from './DataConfidentialityPage.module.css'

function DataConfidentialityPage() {

  return (
    <div className={styles.cguContainer}>
      <Header />
      <h1 className='text-center'>Politique de Confidentialité</h1>
      <p>Date de mise à jour : 1er mai 2025</p><br/>
      <div>
        <p>Chez Spoteet, nous attachons une grande importance à la confidentialité de nos utilisateurs. Cette Politique de Confidentialité vise à vous informer de manière transparente sur la manière dont nous collectons, utilisons, stockons et protégeons vos données personnelles lorsque vous utilisez notre application mobile, notre site web et nos services.</p>
        
        <h2>1. Données collectées</h2>
        <p>Nous collectons uniquement les données nécessaires à la fourniture de nos services :</p>
        <ul>
          <li><strong>Numéro de téléphone</strong> : utilisé pour l’authentification et la sécurité du compte.</li>
          <li><strong>Géolocalisation</strong> : afin de vous proposer du contenu pertinent en fonction de votre position.</li>
          <li><strong>Contenus multimédias</strong> : vidéos, photos et musiques que vous publiez via votre profil.</li>
        </ul>

        <h2>2. Utilisation des données</h2>
        <p>Les données collectées sont utilisées pour :</p>
        <ul>
          <li>Vous permettre d’accéder à votre compte utilisateur,</li>
          <li>Afficher du contenu en fonction de votre localisation,</li>
          <li>Assurer la sécurité et le bon fonctionnement de la plateforme,</li>
          <li>Améliorer nos services et l’expérience utilisateur.</li>
        </ul>
        <p>Vos données ne sont jamais vendues à des tiers.</p>

        <h2>3. Conservation et sécurité</h2>
        <p>Vos données sont conservées de manière sécurisée sur nos serveurs. Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données contre tout accès non autorisé, altération ou destruction.</p>

        <h2>4. Vos droits</h2>
        <p>Conformément à la loi Informatique et Libertés du 6 janvier 1978, vous disposez des droits suivants :</p>
        <ul>
          <li>Droit d’accès à vos données,</li>
          <li>Droit de rectification,</li>
          <li>Droit d’opposition,</li>
          <li>Droit de suppression.</li>
        </ul>
        <p>Vous pouvez exercer ces droits via votre espace personnel dans l'application, ou en nous contactant à l’adresse suivante :</p>
        <p>e-mail : <strong>contact@spoteet.com</strong></p>

        <h2>5. Cookies et technologies similaires</h2>
        <p>Notre site peut utiliser des cookies à des fins de mesure d’audience ou d’optimisation de la navigation. Vous pouvez configurer votre navigateur pour refuser ces cookies.</p>

        <h2>6. Modifications</h2>
        <p>Nous nous réservons le droit de modifier cette politique à tout moment. Vous serez informé de toute mise à jour via l'application ou le site web.</p>

        <h2>7. Contact</h2>
        <p>Pour toute question concernant cette politique ou le traitement de vos données :</p><br/>
        <p>SAS Spoteet<br/>
        8, avenue du Général Balfourier – 75016 Paris</p>


      </div>
    </div>
  );
}

export default DataConfidentialityPage;
